import { useOnMount } from '@wyz/utils';
import * as React from 'react';
import { Route, Routes } from 'react-router';
import { useConfig } from '~/common/context';
import { initUsetiful } from '~/common/helpers';

const AnonymousRouter = React.lazy(() => import('./anonymous/router'));

const UnAuthenticatedApp = () => {
  const config = useConfig();
  useOnMount(() => {
    if (config.usetifulEnabled) {
      initUsetiful();
    }
  });

  return (
    <Routes>
      <Route path='/*' element={<AnonymousRouter />}></Route>
    </Routes>
  );
};
export default UnAuthenticatedApp;
